import axios from '@/http/axios';

export default {
  fetch: (oid, config: any = {}) => {
    return axios.get(`/booking-candidates/${oid}`, config);
  },
  create: (config: any = {}) => {
    return axios.post(`/booking-candidates/`, config);
  },
  update: (candidateId, config: any = {}) => {
    return axios.put(`/booking-candidates/${candidateId}`, config);
  },
  fetchList: (config: any = {}) => {
    return axios.get(`/booking-candidates`, config);
  },
  sendNotification: (candidateId, config: any = {}) => {
    return axios.put(
      `/booking-candidates/${candidateId}/send-notification`,
      config
    );
  },
  candidate: (candidateId, config: any = {}) => {
    return axios.put(`/booking-candidates/${candidateId}/candidate`, config);
  },
  confirmPolicy: (candidateId, config: any = {}) => {
    return axios.put(
      `/booking-candidates/${candidateId}/confirm-policy`,
      config
    );
  },
  startQuestionnaire: (candidateId, config: any = {}) => {
    return axios.put(
      `/booking-candidates/${candidateId}/start-questionnaire`,
      config
    );
  },
  fetchByCandidate: (config: any = {}) => {
    return axios.get(`/candidate-profiles/fetch-by-candidate`, config);
  },
  candidateProfileKeyCheck: (config) => {
    return axios.get(
      `/candidate-profiles/candidate-profile-question-key-check`,
      config
    );
  },
  fetchCandidateProfileItems: (config: any = {}) => {
    return axios.get(`/candidate-profiles/candidate-profile-items`, config);
  },
  consume: (candidateId) => {
    return axios.put(`/booking-candidates/${candidateId}/consume`);
  },
};
